import {
  Component,
  ViewContainerRef,
  OnInit,
  ViewChild,
  ElementRef,
  AfterContentChecked,
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { AccountantService } from "../../accountant/accountant.service";
import { AddAppsModalService } from "./add-apps-modal.service";
import { DashboardService } from "../../../dashboard.service";
import { UntypedFormBuilder, UntypedFormGroup, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import { FormUtil } from "../../../../utils/formutils";
import { HotToastService } from "@ngneat/hot-toast";
import { NgClass, NgIf } from "@angular/common";

@Component({
    selector: "add-apps-modal-component",
    templateUrl: "./add-apps-modal.component.html",
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgClass,
        NgIf,
    ]
})
export class AddAppsModalComponent implements OnInit {
  addAppForm: UntypedFormGroup;
  formUtil: FormUtil;
  fileForm: FormData = new FormData();
  company_id: any;
  company: any;
  addAppFormSubmitAttempt = false;

  @ViewChild("appInput", { static: true }) appInput: ElementRef;

  constructor(
    public bsModalRef: BsModalRef,
    private accountantService: AccountantService,
    private addAppsModalService: AddAppsModalService,
    private localStorage: LocalStorageService,
    private dashboardService: DashboardService,
    private formBuilder: UntypedFormBuilder,
    private toastr: HotToastService,
    vcr: ViewContainerRef
  ) {
    this.company = this.localStorage.get("company");
    this.addAppForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      category: [null, []],
      category_other: [null, []],
      url: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.formUtil = new FormUtil();
  }

  categoryChange(val): void {
    if (val !== "Other Category") {
      this.addAppForm.patchValue({
        category_other: null,
      });
    }
  }

  saveApp(): void {
    this.addAppFormSubmitAttempt = true;
    this.fileForm = new FormData();

    if (this.addAppForm.valid) {
      if (this.appInput !== undefined) {
        const fileList: FileList = this.appInput.nativeElement.files;
        if (fileList.length > 0) {
          const file: File = fileList[0];
          this.fileForm.append("file", file, file.name);
        }
      }

      let category =
        this.addAppForm.get("category_other").value !== null
          ? this.addAppForm.get("category_other").value
          : this.addAppForm.get("category").value;

      this.fileForm.append("name", this.addAppForm.get("name").value);
      this.fileForm.append("category", category);
      this.fileForm.append("url", this.addAppForm.get("url").value);
      this.fileForm.append("company_id", this.company.id);

      this.dashboardService.show_loading.next(true);
      this.accountantService.add_app(this.fileForm).then(
        (res: any) => {
          this.toastr.success("App added successfully!");
          if (this.appInput !== undefined) {
            this.appInput.nativeElement.value = "";
          }

          this.addAppsModalService.app = res.app;
          this.bsModalRef.hide();
          this.dashboardService.show_loading.next(false);
        },
        (err) => {
          console.log(err);
          this.dashboardService.show_loading.next(false);
          this.toastr.error(err.error.message);
        }
      );
    }
  }
}
